import manifest from './manifest.cjs'

const routeJsonLdIds = new Set()
const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined'
const absoluteUrl = (url) => (!url || /^https?:\/\//i.test(url)) ? url : `${manifest.siteOrigin}${url.startsWith('/') ? url : `/${url}`}`

const ensure = (tag, selector, attrs) => {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement(tag)
    document.head.appendChild(element)
  }
  Object.entries(attrs).forEach(([key, value]) => element.setAttribute(key, value || ''))
  return element
}

const removeDuplicates = (selector, key = element => element.outerHTML) => {
  const seen = new Set()
  Array.from(document.head.querySelectorAll(selector)).forEach((element) => {
    const identity = key(element)
    if (seen.has(identity)) element.remove()
    else seen.add(identity)
  })
}

const removeElement = (selector) => {
  const element = document.head.querySelector(selector)
  if (element) element.remove()
}

export const applySeo = (seo = {}) => {
  if (!isBrowser()) return
  if (seo.title) document.title = seo.title

  ensure('meta', 'meta[name="description"]', { name: 'description', content: seo.description })
  ensure('meta', 'meta[name="robots"]', { name: 'robots', content: seo.robots || 'index,follow,max-image-preview:large' })

  if (seo.canonical) ensure('link', 'link[rel="canonical"]', { rel: 'canonical', href: seo.canonical })
  else removeElement('link[rel="canonical"]')

  const pageUrl = seo.canonical || window.location.href
  const image = absoluteUrl(seo.image)
  Object.entries({
    'og:type': 'website',
    'og:site_name': 'Mayon Clinical Laboratory & Medical Services',
    'og:title': seo.socialTitle || seo.title,
    'og:description': seo.socialDescription || seo.description,
    'og:url': pageUrl,
    'og:image': image
  }).forEach(([property, content]) => ensure('meta', `meta[property="${property}"]`, { property, content }))

  Object.entries({
    'twitter:card': 'summary_large_image',
    'twitter:title': seo.socialTitle || seo.title,
    'twitter:description': seo.socialDescription || seo.description,
    'twitter:image': image
  }).forEach(([name, content]) => ensure('meta', `meta[name="${name}"]`, { name, content }))

  const nextIds = new Set((seo.jsonLd || []).map(item => item.id))
  routeJsonLdIds.forEach((id) => {
    if (!nextIds.has(id)) {
      const element = document.getElementById(id)
      if (element) element.remove()
      routeJsonLdIds.delete(id)
    }
  })

  ;(seo.jsonLd || []).forEach((item) => {
    let element = document.getElementById(item.id)
    if (!element) {
      element = document.createElement('script')
      element.type = 'application/ld+json'
      element.id = item.id
      document.head.appendChild(element)
    }
    element.textContent = JSON.stringify(item.data)
    routeJsonLdIds.add(item.id)
  })

  removeDuplicates('meta[name="description"]', element => element.getAttribute('name'))
  removeDuplicates('meta[name="robots"]', element => element.getAttribute('name'))
  removeDuplicates('link[rel="canonical"]', element => element.getAttribute('rel'))
  removeDuplicates('meta[property^="og:"]', element => element.getAttribute('property'))
  removeDuplicates('meta[name^="twitter:"]', element => element.getAttribute('name'))
}
